export const sanitizeQuery = (query) => {
  // remove special characters
  let newQuery = query.replace(/:|\+|\?|&|\/|>|<|\\|\*|%/g, '');

  // remove any non-word/non-Chinese characters from the end of the query
  // characters like period are allowed but not at the end of the query
  if (/\p{Script=Han}/u.test(query)) {
    newQuery = newQuery.replace(/\P{Script=Han}+\s*$/u, '');
  } else {
    newQuery = newQuery.replace(/\W+\s*$/, '');
  }

  // replace tabs and new lines with spaces
  newQuery = newQuery.replace(/\n|\t/g, ' ');

  newQuery = newQuery.trim();

  return newQuery;
};
